import React from 'react'
import {cnModal, Modal} from '../../../../../../components/Modal';
import {cnCreateForm} from '../../../FormModule';
import {Textinput} from '@yandex/ui/Textinput/desktop/bundle';
import {Select} from '../../../../../../components/Select/Select';
import {Button} from '../../../../../../components/Button';

interface IModalFrontPlankProps {
    modal: boolean,
    handleToggleModal: () => void,
    handleSubmit: () => void,
    setNewFrontPlank: (newFrontPlank: Record<string, string | number | boolean>) => void,
    newFrontPlank: Record<string, string | number | boolean>,
    keyValue: string
}

function ModalFrontPlanks({
                              modal,
                              handleToggleModal,
                              handleSubmit,
                              setNewFrontPlank,
                              newFrontPlank,
                              keyValue
                          }: IModalFrontPlankProps) {

    const onInputChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
        setNewFrontPlank({...newFrontPlank, [e.target.name]: e.target.value});
    };
    const onInputChangeNumber = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
        if (!isNaN(+e.target.value)) {
            setNewFrontPlank({...newFrontPlank, [e.target.name]: +e.target.value});
        }
    };

    const onFocus = () => setNewFrontPlank({...newFrontPlank, error: ''});

    const {width, position, error, marginX, marginY, marginZ} = newFrontPlank;

    const edit = keyValue.includes('edit')

    return (
        <Modal
            className={cnCreateForm(cnModal())}
            visible={modal}
            callBack={handleToggleModal}
            key={keyValue}
        >

            <h4 className={cnCreateForm('Header')}>{edit ? 'Редактирование ЛДСП планки' : 'Добавление ЛДСП планки'}</h4>

            <div className={cnCreateForm('Content')}>

                <div>
                    <label htmlFor="length">Ширина планки</label>
                    <Textinput
                        className={cnCreateForm('Textinput')}
                        value={width}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onInputChange(e)}
                        name="width"
                        type="number"
                        maxLength={3}
                        onFocus={onFocus}
                    />
                </div>
                <label htmlFor="position">Положение планки в пространстве</label>
                <Select
                    className={cnCreateForm('Select')}
                    placeholder={"Выберите значение"}
                    showPlaceholder={false}
                    options={[
                        {value: 'top', content: 'Сверху'},
                        {value: 'center', content: 'По центру'},
                        {value: 'bottom', content: 'Снизу'},
                    ]}
                    value={position as string}
                    callBack={(e: React.ChangeEvent<HTMLSelectElement>) => onInputChange({
                        ...e,
                        target: {...e.target, name: 'position'}
                    })}
                />
                <div>
                    <label htmlFor="marginX">Отступ по ширине</label>
                    <Textinput
                        className={cnCreateForm('Textinput')}
                        value={marginX}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onInputChangeNumber(e)}
                        name="marginX"
                        type="number"
                        maxLength={3}
                        onFocus={onFocus}
                    />
                </div>
                <div>
                    <label htmlFor="marginY">Отступ по высоте</label>
                    <Textinput
                        className={cnCreateForm('Textinput')}
                        value={marginY}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onInputChangeNumber(e)}
                        name="marginY"
                        type="number"
                        maxLength={3}
                        onFocus={onFocus}
                    />
                </div>
                <div>
                    <label htmlFor="marginZ">Отступ по глубине</label>
                    <Textinput
                        className={cnCreateForm('Textinput')}
                        value={marginZ}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onInputChangeNumber(e)}
                        name="marginZ"
                        type="number"
                        maxLength={3}
                        onFocus={onFocus}
                    />
                </div>

                {error && <div className='text-danger'>{error}</div>}

            </div>

            <Button
                className={cnCreateForm("Button")}
                type={'button'}
                text={edit ? 'Сохранить' : 'Добавить планку'}
                leftIcon={{path: 'plus2', width: 16, height: 16, marginRight: 8}}
                mods={{
                    mods: {bkg: 'white', color: 'lightGreen', border: 'lightGreen', fill: 'lightGreen'},
                    hover: {mods: {bkg: 'lightGreen', color: 'white', fill: 'white'}}
                }}
                callBack={handleSubmit}
            />
        </Modal>
    )
}

export default ModalFrontPlanks